import { useQuery } from '@tanstack/react-query';
import { FeaturesApi } from '../../../apis/FeaturesApi/FeaturesApi';
import { QueryKeys } from '../../../queryDefaults/QueryKeys';
import { IRoleFeatureConfig } from '../Feature';

export function useRoleFeatureConfig(roleTypeId: number) {
    return useQuery<IRoleFeatureConfig>({
        queryKey: [QueryKeys.roleFeatureConfig, roleTypeId],
        queryFn: () => FeaturesApi.getRoleFeatureConfig(roleTypeId),
    });
}
